module.exports = __webpack_public_path__ + "static/heatwave-1fa1f75adb46d34330cf60753977b31b.jpg";